import { inject, Injector } from '@angular/core';
import { type CanMatchFn } from '@angular/router';

import { DataSourceService } from '@core/data-source/data-source.service';

/**
 * Справочники фильтров аквапарка уходят вместе с проверкой доступа, а не после неё:
 * от их даты актуальности считается период, и без них не уходит ни один блок.
 * Срабатывает при сопоставлении маршрута — до гардов, которые ждут `GET /dashboards`.
 */
export const prefetchAquaparkFilters: CanMatchFn = () => {
  if (!inject(DataSourceService).isMock()) {
    const injector = inject(Injector);

    void import('./aquapark-server.service').then(({ AquaparkServerService }) => {
      injector
        .get(AquaparkServerService)
        .filters()
        .subscribe({ error: () => undefined });
    });
  }

  return true;
};
